export default {
  namespaced: true,
  state: {
    bannersTopHome: [],
    trenddingProductsHome: [],
    sellersProductsHome: []
  },
  getters: {
    getBrandsTopHome(state) {
      return state.bannersTopHome
    },
    getTrenddingProductsHome(state) {
      return state.trenddingProductsHome
    },
    getSellersProductsHome(state) {
      return state.sellersProductsHome
    },
  },
  mutations: {
    setBrandsTopHome(state, payload) {
      const { banners } = payload

      state.bannersTopHome = banners
    },
    setTrenddingProductsHome(state, payload) {
      const { products } = payload

      state.trenddingProductsHome = products
    },
    setSellersProductsHome(state, payload) {
      const { products } = payload

      state.sellersProductsHome = products
    },
  },
  actions: {
    setDataBrandsTopHome({ commit }, payload) {
      commit('setBrandsTopHome', payload)
    },
    setDataTrenddingProductsHome({ commit }, payload) {
      commit('setTrenddingProductsHome', payload)
    },
    setDataSellersProductsHome({ commit }, payload) {
      commit('setSellersProductsHome', payload)
    },
  },
}
